import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Enable Zone.js task-tracking for SSR diagnostics
import 'zone.js/plugins/task-tracking';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
